import React, { useState } from 'react';
import { View } from "react-native"
import CatalogWidget from '../../Componentsv1/CatalogWidget';
import { useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';



const StoreScreen = ({route, navigation}:any) => {
    const [ screen_size, setScreenSize ] = useState({ height:0, width:0 })


    //const app_size:{ width:number, height:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);


    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white, alignItems:'center' }} onLayout={(ev) => {
            const { height, width } = ev.nativeEvent.layout;
            setScreenSize({ height, width })
        }}>
            <CatalogWidget
                width={screen_size.width}
                height={screen_size.height}
                visible={true}
                catalog_id={route.params.catalog_id}
            />
        </View>
    )
}

export default StoreScreen